import React from "react";
import * as R from "ramda";

import {
  withSearchId,
  withNode,
  withoutNode,
  withServiceApi,
  withQueryStringRouting,
  withoutQueryStringRouting,
  withInitialState,
  withInitialDispatch,
} from "./factory";

import {
  initialState as defaultInitialState,
  applyExternalConfig,
  applyResultDisplayStrategy,
} from "./redux/initialState";
import {
  fetchSearchResults as defaultFetchResults,
  mapResponseToState as defaultMapResponseToState,
} from "./redux/service.js";
import { loadResults } from "./redux/search/search.actions";

import {
  mapStateToUrl as defaultMapStateToUrl,
  handleUrlChange as defaultHandleUrlChange,
} from "./redux/routing";

import SearchResultsContainer from "./containers/SearchResultsContainer.jsx";
import SimpleResultsContainer from "./containers/SimpleResultsContainer.jsx";
import QueryContainer from "./containers/QueryContainer.jsx";
import FacetsContainer from "./containers/FacetsContainer.jsx";
import FilterBarContainer from "./containers/FilterBarContainer.jsx";

// Default search app factory function, without any React components
// specified. This is a good "base factory" to use if you want the
// "out-of-box" search config, but with custom components.
export const nodelessDefaultFactory = (searchId) =>
  R.pipe(
    withSearchId(searchId),
    withInitialState(
      defaultInitialState,
      R.pipe(
        applyExternalConfig(window.VelirSiteSearchConfigs, searchId),
        applyResultDisplayStrategy,
      ),
    ),
    withQueryStringRouting(defaultMapStateToUrl, defaultHandleUrlChange),
    withServiceApi(defaultFetchResults, defaultMapResponseToState),
    withInitialDispatch(loadResults),
  );

// Default "out-of-box" search page factory
export const defaultFacetedSearchFactory = (searchId) =>
  R.pipe(
    nodelessDefaultFactory(searchId),
    withNode(".js-search-query", <QueryContainer />),
    withNode(".js-search-results", <SearchResultsContainer />),
    withNode(".js-search-facets", <FacetsContainer />),
  );

// Factory for Dynamic Content Listing apps
export const defaultDynamicContentFactory = (searchId, container, bar) =>
  R.pipe(
    nodelessDefaultFactory(searchId),
    withoutQueryStringRouting(),
    withNode(container, <SimpleResultsContainer />),
    withNode(bar, <FilterBarContainer showSelected={true} />),
  );
